import React from "react";
import RadioOption from "Signups/FamilyRegistration/Shared/RadioOption/RadioOption";
import useUpdateSetting from "Signups/FamilyRegistration/Shared/useUpdateSetting";
import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";
import ErrorMessage from "Signups/FamilyRegistration/Shared/ErrorMessage";

export default function ShowClosingMessageOnly({
  disabled,
  updatingRadioButtons,
  setUpdatingRadioButtons,
}) {
  const { state } = useFamilyRegistrationContext();
  const { updateSetting, saving, error } = useUpdateSetting();

  const enabled =
    state?.familyRegistrationSettings?.finishedActionClosing?.enabled;

  async function handleToggle() {
    if (updatingRadioButtons) return;
    setUpdatingRadioButtons(true);

    let postData = {
      setting: "finishedActionClosing",
      value: !enabled,
    };
    let res = await updateSetting(postData);

    if (res?.finishedActionClosing?.enabled) {
      // enforce 'add closing message' is enabled
      updateSetting({
        setting: "closingMessage",
        value: true,
        action: "toggle",
      });
    }

    setUpdatingRadioButtons(false);
  }

  return (
    <>
      <RadioOption
        selected={enabled}
        disabled={disabled || (updatingRadioButtons && !saving)}
        id={1}
        label="Just show them the closing message"
        loading={saving}
        onClick={handleToggle}
      />

      <ErrorMessage error={error?.error} />
    </>
  );
}
